// Who may open the Discharge Accuracy report, as one light predicate the
// Discharge Plan screen can import without dragging the admin route table -
// and every admin component it lists - into the manageb bundle.
//
// The rule is the server's (WorkflowServer middleware
// requireDischargePlanAccuracyAdmin): the limited admins (145, 152, 190),
// SNF AI's own user (177) and the super-admin tier - the same roles
// ROLES_DISCHARGE_ACCURACY names in admin-routes.config, which a spec there
// holds equal to this. The client flag is the other axis: the report's route
// requires dischargePlan on, and so does the screen that links to it, so a
// link shown here is a link that opens.

import {
  isSnfAdmin,
  isSuperAdmin,
  ROLE_NUMBER_CI_MANAGER,
  ROLE_NUMBER_CLINICAL_MANAGER,
  ROLE_NUMBER_GLOBAL_ADMIN,
} from 'list-types-public';

// 145, 152 and 190 - the three the admin route table resolves to regionAdmin.
const LIMITED_ADMIN_ROLES: readonly number[] = [ROLE_NUMBER_CLINICAL_MANAGER, ROLE_NUMBER_CI_MANAGER, ROLE_NUMBER_GLOBAL_ADMIN];

/** Where the report lives; the admin route table's base plus its path. */
export const DISCHARGE_ACCURACY_URL = '/manageb/admin/discharge-accuracy';

/** Where the planner lives, for the report's way back. */
export const DISCHARGE_PLAN_URL = '/manageb/discharge-plan';

export function canOpenDischargeAccuracy(roleNumber: number | string | null | undefined): boolean {
  const role = Number(roleNumber);
  if (!Number.isFinite(role)) return false;
  return isSuperAdmin(role) || isSnfAdmin(role) || LIMITED_ADMIN_ROLES.includes(role);
}
